import { FC } from 'react';
import { Box, Grid, Typography, IconButton, Toolbar, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface BaseConfigProps {
  title: string;
  onClose: () => void;
  description: string;
  price: string;
  resellerPrice?: string;
  buttons: React.ReactNode;
  children: React.ReactNode;
  onSubmit: () => void;
  errorMessage?: string;
}

const BaseConfig: FC<BaseConfigProps> = ({
  title,
  onClose,
  description,
  price,
  resellerPrice,
  buttons,
  children,
  onSubmit,
  errorMessage,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <Toolbar
        disableGutters
        sx={{
          marginTop: 12,
          marginBottom: 2,
          display: 'flex',
          minHeight: 'initial !important',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Toolbar>
      <Box sx={{ mb: 2 }}>
        <Typography>{description}</Typography>
      </Box>

      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}
      >
        <Grid container spacing={3}>
          {children}
        </Grid>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {price}
          </Typography>
          {resellerPrice && (
            <Typography variant="body2" color="secondary" sx={{ fontWeight: 'bold' }}>
              ÅF: {resellerPrice}
            </Typography>
          )}
        </Box>
        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'flex-end', pb: 4 }}>
          {buttons}
        </Box>
      </Box>
    </Box>
  );
};

export default BaseConfig;
